import { useFileUploader } from './useFileUploader'
const baseUrl = process.env.REACT_APP_GRAPHQL_URL

export const useUploadSopAttachment = () => {
  return useFileUploader({ url: `${baseUrl}/api/files/UploadSopAttachment` })
}
